import { compress } from "micro-graphql-react"

export default compress`
  query($id: ID!) {
    student(id: $id) {
      firstName
      lastName
      email
      username
      phoneNumber
      emailTimeZone
      parentName
      parentEmail
      parentPhoneNumber
      secondaryParentName
      secondaryParentEmail
      secondaryParentPhoneNumber
      noShowCount
      couponCode
      enableSessionEmails
      messageEmailsEnabled
      smsNotificationsEnabled
      hasActAccess
      hasSatAccess
      hasIseeAccess
      stateAssignedUid
      notes
      prepaidHours
      messagingDisabled

      school {
        id
        name
      }

      tags {
        id
        name
      }

      referralSource {
        label
        value
      }

      subjects {
        id
        name
      }

      grade {
        id
        name
      }

      parent {
        id
        fullName
        email
        phoneNumber
      }

      organization {
        id
        name
        studentMessagingDisabled
      }
    }
  }
`
